import React from 'react'
import s from './AddressList.less'
import { useSelector } from 'react-redux'
import { selectAddresses } from '../../store/address/address.selectors'
import AddressItem from './AddressItem'

export default function AddressList() {
  const addresses = useSelector(selectAddresses)

  if (addresses.length <= 1) return <></>

  return (
    <div className={s.AddressList}>
      <ul>
        {addresses.map((address, idx) => (
          <li key={idx}>
            <AddressItem address={address} />
          </li>
        ))}
      </ul>
    </div>
  )
}
